import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    data: [],
    page: 1,
    page_size: 10,
    order_column: 'id',
    order_type: 'desc'
  },

  mutations: {
    setData(state, payload) {
      state.data = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('tracks_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('track', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setData', r.data.data)
          commit('setLoading', false)
        })
        .catch(e => {
          Message({
            message: e.response.statusText,
            type: 'error'
          })
          commit('setLoading', false)
        })
    }
  },

  getters: {}
}
